module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel latest-galleries"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('scroll-area', {
    ref: "scrollbar",
    attrs: {
      "showScrollbar": false,
      "dragScrollEnabled": true
    }
  }, [_c('ol', _vm._l((_vm.galleryList.galleries), function(gallery) {
    return _c('li', {
      staticClass: "gallery-thumb"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getGalleryLocation(gallery)
      },
      nativeOn: {
        "click": function($event) {
          _vm.onGalleryClick($event, gallery)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": gallery.thumbnailMedia.url
      }
    })])], 1)
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d98598f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LatestGalleries.vue
// module id = 2044
// module chunks = 2